module.exports = __webpack_public_path__ + "img/descargar.66fe5d82.png";